function removeQuotes(str) {
  return str.replace(/&quot;/g, '');
}

export {
  removeQuotes
};
